import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {call, put, select} from 'redux-saga/effects';
import Covert from 'covert';
import config from 'config';
import {selectUserLoaded} from 'flows/session/selectors';
import {selectEnv} from 'reducers/env';
import {EVENTS, selectToken} from './utils';

const api = config.cove.api;
const CoveApi = Covert({api});

const namespace = 'api/users';

// Actions
export const GET_USERINFO = defineAction('GET_USERINFO', EVENTS, namespace);
export const getUserInfo = createAction(GET_USERINFO.ACTION);
export const getUserInfoRequested = createAction(GET_USERINFO.REQUESTED);
export const getUserInfoSuccess = createAction(GET_USERINFO.SUCCESS);
export const getUserInfoError = createAction(GET_USERINFO.ERROR);

// API Calls
export const getUserInfoApi = token => CoveApi.users.info({token});

// Get User Info Saga
export function* getUserInfoSaga() {
  const loaded = yield select(selectUserLoaded);
  if (!loaded) {
    yield put(getUserInfoRequested());
    try {
      const token = yield select(selectToken);
      const data = yield call(getUserInfoApi, token);

      const env = yield select(selectEnv);
      if (env.web) {
        yield call([window.Raven, window.Raven.setUserContext], {id: data.id});
        yield call([window.mixpanel, window.mixpanel.identify], data.id);
        yield call([window.mixpanel.people, window.mixpanel.people.set], {$name: data.id});
      }
      yield put(getUserInfoSuccess({data}));
    } catch (error) {
      yield put(getUserInfoError({error}));
      return error;
    }
  }
}



// WEBPACK FOOTER //
// ./mobile/shared/api/users.js